export enum DeviceOs {
  Android = "android",
  Ios = "ios",
  Other = "other"
}
